import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  SimpleTable,
  Pagination,
  Alert,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../utils/Loader";
import { parseJwt } from "../utils/utils";

const { Text } = Inputs;

function HorariosList({ history, match }) {
  const dispatch = useDispatch();
  const [servicioFiltro, setServicioFiltro] = useState(null);
  const [profesionalFiltro, setProfesionalFiltro] = useState(null);
  const [diaFiltro, setDiaFiltro] = useState(null);
  const [horaFiltro, setHoraFiltro] = useState(null);
  const [actualRol, setActualRol] = useState(null);

  const modelHorarios = useSelector((state) => state.horariosByLocal);
  const modelEliminarHorario = useSelector((state) => state.eliminarHorario);
  const modelPendientes = useSelector((state) => state.simularPendientes);
  const modelEliminarHorariosByLocal = useSelector(
    (state) => state.eliminarHorariosByLocal
  );

  const [horarios, setHorarios] = useState(null);
  const [totalResultsHorarios, setTotalResultsHorarios] = useState(0);
  const [activePageHorarios, setActivePageHorarios] = useState(0);
  const [pageSizeHorarios, setPageSizeHorarios] = useState(5);

  useEffect(() => {
    const data = modelPendientes?.data?.data;
    const error = modelPendientes?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckSimularPendientes.actions.clear());
    }
    if (data) {
      alert("Horarios pendientes procesados");
      handlePageHorarios(0);
      dispatch(controller.duckSimularPendientes.actions.clear());
    }
  }, [modelPendientes]);

  useEffect(() => {
    const data = modelEliminarHorario?.data?.data;
    const error = modelEliminarHorario?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckEliminarHorario.actions.clear());
    }
    if (data) {
      handlePageHorarios(0);
      dispatch(controller.duckEliminarHorario.actions.clear());
    }
  }, [modelEliminarHorario]);

  useEffect(() => {
    const data = modelEliminarHorariosByLocal?.data?.data;
    const error = modelEliminarHorariosByLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckEliminarHorariosByLocal.actions.clear());
    }
    if (data) {
      handlePageHorarios(0);
      dispatch(controller.duckEliminarHorariosByLocal.actions.clear());
    }
  }, [modelEliminarHorariosByLocal]);

  useEffect(() => {
    const data = modelHorarios?.data?.data;
    const error = modelHorarios?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckHorariosByLocal.actions.clear());
    }
    if (data) {
      setHorarios(data.data.items);
      setTotalResultsHorarios(data.data.total);

      dispatch(controller.duckHorariosByLocal.actions.clear());
    }
  }, [modelHorarios]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    const decodedToken = parseJwt(token);

    setActualRol(decodedToken.rol);
    dispatch(
      controller.horariosByLocalThunk(
        match.params.organizacion,
        1,
        pageSizeHorarios,
        profesionalFiltro,
        servicioFiltro,
        diaFiltro,
        horaFiltro
      )
    );
  }, []);

  function simularPendientes(page) {
    dispatch(
      controller.procesarHorariosPendientesThunk({
        localId: match.params.organizacion,
      })
    );
  }

  function handlePageHorarios(page) {
    setActivePageHorarios(page);
    setHorarios([]);
    dispatch(
      controller.horariosByLocalThunk(
        match.params.organizacion,
        page + 1,
        pageSizeHorarios,
        profesionalFiltro,
        servicioFiltro,
        diaFiltro,
        horaFiltro
      )
    );
  }

  function eliminarHorario(data) {
    var answer = window.confirm(
      "¿Esta seguro que desea eliminar este horario?"
    );
    if (answer) {
      let datos = {
        _id: data._id,
        id: data._id,
        dia: data.numeroDia,
        duracion: data.duracion,
        inicio: data.inicio,
        fin: data.fin,
        servicioId: data.foreingKey,
        profesionalId: data.extraKey.profesionalId,
        localId: data.localId,
      };

      dispatch(controller.eliminarHorarioThunk(datos));
    }
  }

  function eliminarHorariosLocal(data) {
    var answer = window.confirm(
      "¿Esta seguro que desea eliminar los horarios del local?"
    );
    if (answer) {
      let datos = {
        localId: match.params.organizacion,
      };

      dispatch(controller.eliminarHorariosByLocalThunk(datos));
    }
  }

  return (
    <Content title="Local" subTitle="Local" browserTitle="Local" show={false}>
      <Row>
        <Col md="12">
          <Box title="Horarios">
            <Col md="12">
              <Alert type="warning" title="Aviso">
                <p>
                  Los registros pendientes seran procesados a la medianoche.
                  Solo luego de esto regiran como horarios.
                </p>
              </Alert>
            </Col>
            <Col md="12">
              <Col md="3">
                <Text
                  labelPosition="above"
                  size="sm"
                  label="Dia"
                  value={diaFiltro}
                  onChange={(evt) => setDiaFiltro(evt.target.value)}
                />
              </Col>
              <Col md="3">
                <Text
                  labelPosition="above"
                  size="sm"
                  label="Hora"
                  value={horaFiltro}
                  onChange={(evt) => setHoraFiltro(evt.target.value)}
                />
              </Col>
              <Col md="3">
                <Text
                  labelPosition="above"
                  size="sm"
                  label="Profesional"
                  value={profesionalFiltro}
                  onChange={(evt) => setProfesionalFiltro(evt.target.value)}
                />
              </Col>
              <Col md="3">
                <Text
                  labelPosition="above"
                  size="sm"
                  label="Servicio"
                  value={servicioFiltro}
                  onChange={(evt) => setServicioFiltro(evt.target.value)}
                />
              </Col>
              <Col md="3">
                <div style={{ marginTop: 15 }}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePageHorarios(0)}
                  />
                </div>
              </Col>
            </Col>

            <Col md="12">
              <div style={{ marginTop: 15 }}>
                <Button
                  type="primary"
                  text="Agregar"
                  pullRight={true}
                  onClick={() =>
                    history.push(`/nuevoHorario/${match.params.organizacion}`)
                  }
                />
                {actualRol === "superadmin" ? (
                  <>
                    <Button
                      type="primary"
                      text="Procesar pendientes"
                      onClick={() => simularPendientes()}
                    />
                    <Button
                      style={{ marginLeft: 20 }}
                      type="danger"
                      text="Eliminar horarios del local"
                      onClick={() => eliminarHorariosLocal()}
                    />
                  </>
                ) : (
                  <></>
                )}

                <div>
                  <span>Total: {totalResultsHorarios}</span>
                </div>
              </div>
            </Col>

            <Col md="12">
              <Loader
                isLoading={
                  modelHorarios.loading ||
                  modelEliminarHorario.loading ||
                  modelPendientes.loading
                }
              >
                {horarios && horarios.length > 0 ? (
                  <SimpleTable
                    hover={true}
                    data={horarios.map((row, index) => {
                      return {
                        dia: row.dia,
                        inicio: row.inicio,
                        fin: row.fin,
                        servicio: row.servicioNombre,
                        profesional: row.profesionalNombre,
                        estado: row.estado ? row.estado : "ACTIVO",
                        editar: (
                          <Button
                            type="primary"
                            text="Editar"
                            onClick={() =>
                              history.push(`/editarHorario/${row._id}`)
                            }
                          />
                        ),
                        eliminar: (
                          <Button
                            type="danger"
                            text="Eliminar"
                            onClick={() => eliminarHorario(row)}
                          />
                        ),
                      };
                    })}
                    columns={[
                      { title: "Dia", data: "dia" },
                      { title: "Inicio", data: "inicio" },
                      { title: "Fin", data: "fin" },
                      { title: "Servicio", data: "servicio" },
                      { title: "Profesional", data: "profesional" },
                      { title: "Editar", data: "editar" },
                      { title: "Estado", data: "estado" },
                      { title: "Eliminar", data: "eliminar" },
                    ]}
                  />
                ) : (
                  <Col md="12">
                    <h4>No se han encontrado horarios</h4>
                  </Col>
                )}
              </Loader>
            </Col>
            <Pagination
              activePage={activePageHorarios}
              pageSize={pageSizeHorarios}
              totalElements={totalResultsHorarios}
              onChange={handlePageHorarios}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResultsHorarios}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default HorariosList;
